import Vue from "vue";
import training from "./teacher/training";
import application from "./teacher/application";
import assessment from "./teacher/assessment";

const view = Vue.extend({ render: h => h("router-view") });

// 通用 家长期望
const parentHope = () =>
  import(
    /* webpackChunkName: "parent-hope" */ "@/views/teacher/parentHope/index.vue"
  );
// 老师-课件列表
const lessonPlanList = () =>
  import(
    /* webpackChunkName: "lesson-plan-list" */ "@/views/teacher/lessonPlan/list.vue"
  );
// 老师-课件详情
const lessonPlanDetail = () =>
  import(
    /* webpackChunkName: "lesson-plan-detail" */ "@/views/teacher/lessonPlan/detail.vue"
  );
// 老师-学员详情
const studentInfo = () =>
  import(
    /* webpackChunkName: "student-info" */ "@/views/teacher/studentInfo/index.vue"
  );
// 老师课时明细
const classDetails = () =>
  import(
    /* webpackChunkName: "class-details" */ "@/views/teacher/classDetails/index.vue"
  );
// 老师课件预览
const courseView = () =>
  import(
    /* webpackChunkName: "course-view" */ "@/views/teacher/lessonPlan/courseView.vue"
  );
// 老师作品集预览
const worksView = () =>
  import(
    /* webpackChunkName: "works-view" */ "@/views/teacher/studentInfo/worksView.vue"
  );
// 老师简历
const teacherResume = () =>
  import(
    /* webpackChunkName: "teacher-resume" */ "@/views/teacher/resume/index.vue"
  );
// 老师简历
const changeResume = () =>
  import(
    /* webpackChunkName: "change-resume" */ "@/views/teacher/resume/changeResume.vue"
  );
// 老师邀约课程页面
const inviteLesson = () =>
  import(
    /* webpackChunkName: "invite-lesson" */ "@/views/teacher/inviteLesson/index.vue"
  );

// 老师邀约课程接受拒绝页面
const chooseLesson = () =>
  import(
    /* webpackChunkName: "choose-lesson" */ "@/views/teacher/inviteLesson/chooseLesson/index.vue"
  );
// 投诉建议
const complaints = () =>
  import(
    /* webpackChunkName: "complaints" */ "@/views/teacher/complaints/advice.vue"
  );
// 投诉反馈
const feedback = () =>
  import(
    /* webpackChunkName: "feedback" */ "@/views/teacher/complaints/feedback.vue"
  );
// 个人中心-奖励明细
const rewardDetail = () =>
  import(
    /* webpackChunkName: "reward-detail" */ "@/views/teacher/rewardDetail/index.vue"
  );
// 老师每月活动
const monthlyActivity = () =>
  import(
    /* webpackChunkName: "teacher-monthlyActivity" */ "@/views/teacher/monthlyActivity/index.vue"
  );
// 老师每月活动-活动报名
const activityRegistration = () =>
  import(
    /* webpackChunkName: "teacher-monthlyActivity" */ "@/views/teacher/monthlyActivity/activityRegistration.vue"
  );
// 教师转介绍 邀请海报选择页
const teacherInvitePoster = () =>
  import(
    /* webpackChunkName: "teacher-invites" */ "@/views/teacher/teacherInvitePoster/index.vue"
  );
// 教师转介绍 邀请海报生成页
const teacherInvitePosterGenerate = () =>
  import(
    /* webpackChunkName: "teacher-invites" */ "@/views/teacher/teacherInvitePoster/posterGenerate/index.vue"
  );
// 教师转介绍 邀请老师奖励明细
const teacherRewardDetail = () =>
  import(
    /* webpackChunkName: "teacher-invites" */ "@/views/teacher/teacherInvitePoster/teacherRewardDetail/index.vue"
  );
// 班主任详情
const teacherInfo = () =>
  import(
    /* webpackChunkName: "teacher-interview" */ "@/views/teacher/teacherInfo/index.vue"
  );
// 老师报名入口
const welcome = () =>
  import(
    /* webpackChunkName: "teacher-monthlyActivity" */ "@/views/teacher/welcome/index.vue"
  );
// 离职须知
const dimissionNotice = () =>
  import(
    /* webpackChunkName: "dimission-notice" */ "@/views/teacher/dimission/dimissionNotice.vue"
  );
// 离职进展
const dimissionApply = () =>
  import(
    /* webpackChunkName: "dimission-apply" */ "@/views/teacher/dimission/dimissionApply.vue"
  );
// 离职交接单
const dimissionDelivery = () =>
  import(
    /* webpackChunkName: "dimission-delivery" */ "@/views/teacher/dimission/dimissionDelivery.vue"
  );
// 离职进度
const progressSpeed = () =>
  import(
    /* webpackChunkName: "dimission-progress-speed" */ "@/views/teacher/dimission/progressSpeed.vue"
  );
// 评价详情
const evaluationDetail = () =>
  import(
    /* webpackChunkName: "teacher-evaluationDetail" */ "@/views/teacher/components/userEvaluationComp.vue"
  );
// 人脸识别协议
const recognitionProto = () =>
  import(
    /* webpackChunkName: "recognitionProto" */ "@/views/teacher/recognitionProto/index.vue"
  );
// 请假
const leaveIndex = () =>
  import(
    /* webpackChunkName: "leave-index" */ "@/views/teacher/leave/index.vue"
  );
// 填写请假信息
const leaveInfo = () =>
  import(/* webpackChunkName: "leave-info" */ "@/views/teacher/leave/info.vue");
// 请假详情
const leaveDetails = () =>
  import(
    /* webpackChunkName: "leave-detail" */ "@/views/teacher/leave/details.vue"
  );
// 查看示例
const leaveExample = () =>
  import(
    /* webpackChunkName: "leave-example" */ "@/views/teacher/leave/example.vue"
  );
// 操作规范
const operation = () =>
  import(
    /* webpackChunkName: "operation" */ "@/views/teacher/resume/operation.vue"
  );
// 校验是否是应聘老师
const checkPhone = () =>
  import(
    /* webpackChunkName: "checkPhone" */ "@/views/teacher/checkPhone/index.vue"
  );
// 我的设备
const applyDevice = () =>
  import(
    /* webpackChunkName: "apply-device" */ "@/views/teacher/applyDevice/index.vue"
  );
// 申请成功
const applyDeviceSuccess = () =>
  import(
    /* webpackChunkName: "apply-device-success" */ "@/views/teacher/applyDevice/success.vue"
  );
// 收货地址
const applyDeviceAddress = () =>
  import(
    /* webpackChunkName: "apply-device-address" */ "@/views/teacher/applyDevice/address.vue"
  );
// 申请列表
const applyDeviceList = () =>
  import(
    /* webpackChunkName: "apply-device-list" */ "@/views/teacher/applyDevice/list.vue"
  );
// 设备物流详情
const applyDeviceLogistics = () =>
  import(
    /* webpackChunkName: "apply-device-logistics" */ "@/views/teacher/applyDevice/logistics.vue"
  );

// 个人中心质检报告
const qualityReport = () =>
  import(
    /* webpackChunkName: "qualityReport-index" */ "@/views/teacher/qualityReport/index.vue"
  );
// 质检报告详情
const reportDetail = () =>
  import(
    /* webpackChunkName: "qualityReport-qualityReport" */ "@/views/teacher/qualityReport/reportDetail/index.vue"
  );
// 质检报告申诉
const complainPage = () =>
  import(
    /* webpackChunkName: "qualityReport-qualityReport" */ "@/views/teacher/qualityReport/complainPage/index.vue"
  );
// 质检报告申诉详情
const appealDetail = () =>
  import(
    /* webpackChunkName: "qappeal-detail" */ "@/views/teacher/qualityReport/appealDetail.vue"
  );
//  第三方信息共享清单
const appSdkList = () =>
  import(
    /* webpackChunkName: "appSdkList" */ "@/views/teacher/appInfoList/sdkList/index.vue"
  );
// 警告函
const warningLetter = () =>
  import(
    /* webpackChunkName: "warningLetter" */ "@/views/teacher/appInfoList/letter/index.vue"
  );
//  个人信息收集清单
const appPersonList = () =>
  import(
    /* webpackChunkName: "appPersonList" */ "@/views/teacher/appInfoList/personList/index.vue"
  );
// 隐私协议
const privacy = () =>
  import(
    /* webpackChunkName: "privacy" */ "@/views/teacher/protocol/privacy.vue"
  );
// 弹窗更新文案
const modalUpdate = () =>
  import(
    /* webpackChunkName: "modal-update" */ "@/views/teacher/protocol/modalUpdate.vue"
  );
// 一对一公众号请假审批
const leaveExamine = () =>
  import(
    /* webpackChunkName: "leave-examine" */ "@/views/teacher/leave/leaveExamine/index.vue"
  );
// 违规记录-违规列表
const violationsList = () =>
  import(
    /* webpackChunkName: "violations-list" */ "@/views/teacher/violationsRecord/list.vue"
  );
// 违规记录-违规详情
const violationsDetails = () =>
  import(
    /* webpackChunkName: "violations-detail" */ "@/views/teacher/violationsRecord/detail.vue"
  );
// 违规记录-提交申诉
const violationsSubmit = () =>
  import(
    /* webpackChunkName: "violations-submit" */ "@/views/teacher/violationsRecord/submit.vue"
  );
// 个性化约课详情
const individuationClassDetail = () =>
  import(
    /* webpackChunkName: "reservationLessonPlan-individuation-detail" */ "@/views/teacher/reservationLessonPlan/individuationDetail.vue"
  );
// 课件备课
const courseWarePrepareLessons = () =>
  import(
    /* webpackChunkName: "prepareLessons-courseWarePrepareLessons" */ "@/views/teacher/prepareLessons/courseWarePrepareLessons.vue"
  );
// 个性化课程备课
const individuationPrepareLessons = () =>
  import(
    /* webpackChunkName: "prepareLessons-individuationPrepareLessons" */ "@/views/teacher/prepareLessons/individuationPrepareLessons.vue"
  );
// 个性化课程备课
const certificateExample = () =>
  import(
    /* webpackChunkName: "resume-certificateExample" */ "@/views/teacher/resume/certificateExample.vue"
  );

// 教师转介绍学生 邀请海报选择页
const studentInvitePoster = () =>
  import(
    /* webpackChunkName: "teacher-invites" */ "@/views/teacher/studentInvite/index.vue"
  );
// 教师转介绍学生 邀请海报生成页
const studentInvitePosterGenerate = () =>
  import(
    /* webpackChunkName: "teacher-invites" */ "@/views/teacher/studentInvite/posterGenerate/index.vue"
  );
// 教师转介绍学生 邀请学生奖励明细
const studentRewardDetail = () =>
  import(
    /* webpackChunkName: "teacher-invites" */ "@/views/teacher/studentInvite/rewardDetail/index.vue"
  );

export default {
  path: "/teacher",
  component: view,
  children: [
    training,
    application,
    assessment,
    {
      path: "parentHope",
      component: parentHope
    },
    {
      name: "lessonPlanList",
      path: "lessonPlanList",
      component: lessonPlanList
    },
    {
      name: "lessonPlanDetail",
      path: "lessonPlanDetail",
      component: lessonPlanDetail
    },
    {
      name: "courseView",
      path: "courseView",
      component: courseView
    },
    {
      name: "studentInfo",
      path: "studentInfo",
      component: studentInfo
    },
    {
      name: "worksView",
      path: "worksView",
      component: worksView
    },
    {
      name: "classDetails",
      path: "classDetails",
      component: classDetails
    },
    {
      name: "teacherResume",
      path: "teacherResume",
      component: teacherResume
    },
    {
      name: "changeResume",
      path: "changeResume",
      component: changeResume,
      meta: {
        keepAlive: true
      }
    },
    {
      name: "inviteLesson",
      path: "inviteLesson",
      component: inviteLesson
    },
    {
      name: "chooseLesson",
      path: "chooseLesson",
      component: chooseLesson
    },
    {
      name: "complaints",
      path: "complaints",
      component: complaints
    },
    {
      name: "feedback",
      path: "feedback",
      component: feedback
    },
    {
      name: "rewardDetail",
      path: "rewardDetail",
      component: rewardDetail
    },
    {
      name: "monthlyActivity",
      path: "monthlyActivity",
      component: view,
      children: [
        {
          name: "activityRegistration",
          path: "activityRegistration",
          component: activityRegistration
        },
        {
          path: "index",
          component: monthlyActivity
        }
      ]
    },
    {
      name: "teacherInvitePoster",
      path: "teacherInvitePoster",
      component: teacherInvitePoster
    },
    {
      name: "generate",
      path: "generate",
      component: teacherInvitePosterGenerate
    },
    {
      name: "teacherRewardDetail",
      path: "teacherRewardDetail",
      component: teacherRewardDetail
    },
    {
      name: "welcome",
      path: "welcome",
      component: welcome
    },
    {
      name: "teacherInfo",
      path: "teacherInfo",
      component: teacherInfo
    },
    {
      name: "dimissionNotice",
      path: "dimissionNotice",
      component: dimissionNotice
    },
    {
      name: "dimissionApply",
      path: "dimissionApply",
      component: dimissionApply
    },
    {
      name: "dimissionDelivery",
      path: "dimissionDelivery",
      component: dimissionDelivery
    },
    {
      name: "progressSpeed",
      path: "progressSpeed",
      component: progressSpeed
    },
    {
      name: "evaluationDetail",
      path: "evaluationDetail",
      component: evaluationDetail
    },
    {
      name: "recognitionProto",
      path: "recognitionProto",
      component: recognitionProto
    },
    {
      name: "leaveIndex",
      path: "leaveIndex",
      component: leaveIndex,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "leaveInfo",
      path: "leaveInfo",
      component: leaveInfo
    },
    {
      name: "leaveDetails",
      path: "leaveDetails",
      component: leaveDetails
    },
    {
      name: "leaveExample",
      path: "leaveExample",
      component: leaveExample
    },
    {
      path: "operation",
      component: operation
    },
    {
      name: "checkPhone",
      path: "checkPhone",
      component: checkPhone
    },
    {
      name: "applyDevice",
      path: "applyDevice",
      component: applyDevice,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "applyDeviceSuccess",
      path: "applyDeviceSuccess",
      component: applyDeviceSuccess
    },
    {
      name: "applyDeviceAddress",
      path: "applyDeviceAddress",
      component: applyDeviceAddress
    },
    {
      name: "applyDeviceList",
      path: "applyDeviceList",
      component: applyDeviceList,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "applyDeviceLogistics",
      path: "applyDeviceLogistics",
      component: applyDeviceLogistics
    },
    {
      name: "qualityReport",
      path: "qualityReport",
      component: qualityReport,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "reportDetail",
      path: "reportDetail",
      component: reportDetail
    },
    {
      name: "complainPage",
      path: "complainPage",
      component: complainPage
    },
    {
      name: "appealDetail",
      path: "appealDetail",
      component: appealDetail
    },
    {
      name: "appSdkList",
      path: "appSdkList",
      component: appSdkList
    },
    {
      name: "warningLetter",
      path: "warningLetter",
      component: warningLetter
    },
    {
      name: "appPersonList",
      path: "appPersonList",
      component: appPersonList
    },
    {
      name: "privacy",
      path: "privacy",
      component: privacy
    },
    {
      name: "modalUpdate2",
      path: "modalUpdate",
      component: modalUpdate
    },
    {
      name: "leaveExamine",
      path: "leaveExamine",
      component: leaveExamine
    },
    {
      name: "violationsList",
      path: "violationsList",
      component: violationsList,
      meta: {
        keepAlive: true
      }
    },
    {
      name: "violationsDetails",
      path: "violationsDetails",
      component: violationsDetails
    },
    {
      name: "violationsSubmit",
      path: "violationsSubmit",
      component: violationsSubmit
    },
    {
      name: "individuationClassDetail",
      path: "individuationClassDetail",
      component: individuationClassDetail
    },
    {
      name: "courseWarePrepareLessons",
      path: "courseWarePrepareLessons",
      component: courseWarePrepareLessons
    },
    {
      name: "individuationPrepareLessons",
      path: "individuationPrepareLessons",
      component: individuationPrepareLessons
    },
    {
      name: "studentInvite",
      path: "studentInvite",
      component: studentInvitePoster
    },
    {
      name: "studentGenerate",
      path: "studentGenerate",
      component: studentInvitePosterGenerate
    },
    {
      name: "studentRewardDetail",
      path: "studentRewardDetail",
      component: studentRewardDetail
    },
    {
      name: "certificateExample",
      path: "certificateExample",
      component: certificateExample
    }
  ]
};
